export default __webpack_public_path__ + "static/media/datasources_free_tier.8ec896e6.svg";